<template>
  <AppBarLayout>
    <template #default>
      <div class="main tw-overflow-x-hidden">
        <BrandPattern4 page="APPBARLAYOUT" />
        <BackgroundComponent ref="backgroundRef" />
        <!--
 <ActivePathWrapper
          class="tw-bg-[#FFFFFF] !tw-shadow-none"
          :active-hierarchy="activeHierarchy"
        /> 
-->
        <div id="click-box-container" class="tw-w-full scanning-container">
          <!-- Header -->
          <div
            class="header-container tw-bg-[#FFFFFF] tw-py-[55px] md:tw-px-[60px] tw-px-[10px] tw-w-full tw-border-x-0 tw-border-t-0 tw-border-b-[1px] !tw-border-solid !tw-border-[#EFF0F1]"
          >
            <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
              <span class="title tw-text-2xl tw-font-semibold">{{
                getComponentUiText("app-menu-submenu-scan-scanning-1")
              }}</span>
            </div>
            <NoteInfo
              v-if="notInfoVisible"
              class="custom-info"
              @close="() => (notInfoVisible = false)"
            >
              <span class="tw-text-[#211F58] tw-text-[15px]">{{
                getComponentUiText("app-assess-recommendations-tip-top")
              }}</span>
              <a
                href="#"
                class="tw-underline tw-text-[#387DFF] tw-text-[15px]"
                >{{
                  getComponentUiText(
                    "app-assess-recommendations-tip-top-link-1",
                  )
                }}</a
              >
            </NoteInfo>
            <div class="overview-container tw-flex tw-gap-[20px] tw-mt-[40px]">
              <!-- Scan -->
              <div
                class="tw-flex-1 tw-h-[185px] tw-rounded-md tw-border-solid tw-border tw-border-[#EFF0F1] scan-card"
              >
                <ScanMiniDashCard :loading="loading" />
              </div>
              <!-- Issues -->
              <div class="tw-flex-1 tw-h-[185px]">
                <IssuesMiniDashCard :loading="loading" />
              </div>
              <!-- Issues over time -->
              <div class="tw-flex-1 tw-h-[185px]">
                <IssuesOverTime :loading="loading" />
              </div>
            </div>
          </div>

          <!-- body -->
          <div
            class="body-container tw-flex-col tw-gap-[55px] tw-pt-[41px] tw-px-[60px] tw-pb-[65px] content"
          >
            <!-- Scanning targets -->
            <div id="scan-targets-container" class="tw-w-full">
              <div
                class="section-header-actions tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-[20px]"
              >
                <span class="tw-text-[18px] tw-text-[#211F58] tw-font-semibold">
                  {{ getComponentUiText("app-scan-title-scanning-targets-1") }}
                </span>
                <div class="tw-flex tw-items-center tw-justify-end">
                  <div @click="handleShowBulkAction">
                    <ButtonBulkActions
                      :active="isShowBulkActions"
                      :id-popover="'popover-button-bulk-actions-scanning'"
                      :button-class="`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1] tw-mr-[20px]`"
                      :show-more-actions="isShowMoreActions"
                      :show-acction-click="true"
                      :selected-number="
                        selectedWebServicesRows.length +
                        selectedDomainsRows.length
                      "
                    >
                      <CustomDropDownItem
                        :style="'normal'"
                        :id-text="'app-scan-title-scanning-dropdown-option-scan-targets-1'"
                        @click="scanTargets"
                      />
                      <CustomDropDownItem
                        :style="'normal'"
                        :id-text="'app-scan-title-scanning-dropdown-option-schedule-targets-1'"
                        @click="scheduleTargets"
                      />
                      <CustomDropDownItem
                        :style="'normal'"
                        :id-text="'app-scan-title-scanning-dropdown-option-ignore-1'"
                      />
                    </ButtonBulkActions>
                  </div>
                  <ButtonFilter
                    :active="false"
                    :button-class="`tw-mr-[20px] !tw-border !tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`"
                    :id-popover="'popover-btn-filter-scanning'"
                  />
                  <IconButton
                    :id="'scan-btn-add-scanning-target'"
                    src="/img/plus_icon.svg"
                    @click="handleAddScanningTarget"
                  />
                </div>
              </div>
              <!-- Web services -->
              <div
                id="scan-table-web-services"
                class="tw-w-full tw-flex tw-flex-col tw-gap-[20px] tw-mb-[30px]"
              >
                <div
                  class="tw-text-[#211F58] tw-text-[15px] tw-font-semibold tw-leading-[130%]"
                >
                  {{ getComponentUiText("app-scan-sub-title-web-services-1") }}
                </div>
                <!-- Web services content -->
                <div class="tw-bg-white tw-w-full sticky-table-wrapper">
                  <WebServicesTargetTable
                    :loading="isLoadingWebServiceTable"
                    @update-selected-rows="
                      updateWebServicesSelectedRows($event)
                    "
                  />
                </div>
              </div>
              <!-- Domains -->
              <div
                id="scan-table-domains"
                class="tw-w-full tw-flex tw-flex-col tw-gap-[20px] tw-mb-[30px]"
              >
                <div
                  class="tw-text-[#211F58] tw-text-[15px] tw-font-semibold tw-leading-[130%]"
                >
                  {{
                    getComponentUiText("app-menu-submenu-settings-domains-1")
                  }}
                </div>
                <!-- Domains content -->
                <div class="tw-bg-white tw-w-full sticky-table-wrapper">
                  <DomainsTargetTable
                    :loading="isLoadingDomainTable"
                    @update-selected-rows="updateDomainsSelectedRows($event)"
                  />
                </div>
              </div>
              <!-- Button bottom -->
              <div
                class="tw-flex tw-w-full tw-justify-end tw-items-center tw-gap-3"
              >
                <ButtonDropdown
                  :id-btn="`scan-btn-selected-targets`"
                  :id-popover="'popover-btn-dropdown-scanning'"
                  :custom-class="'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
                  :classes="`!tw-leading-none `"
                  :button-class="'tw-min-w-[133px] tw-border-none tw-bg-[#387DFF] tw-cursor-pointer tw-color-[#fff] tw-cursor-pointer hover:tw-opacity-90'"
                  :color-text="`#FFF`"
                  :disabled="true"
                  :title="
                    getComponentUiText(
                      'app-scan-button-title-scan-selected-targets-1',
                    )
                  "
                  :active="isShowBulkActions"
                  :arrow-class="isShowDropdownActions ? 'tw-rotate-180' : ''"
                  :active-dropdown="isShowDropdownActions"
                  :is-loading-animation="isUpdateScanTargets"
                  :with-btn="`173px`"
                  @click-title="scanTargets"
                  @click-dropdown="handleClickShowDropdown"
                >
                  <CustomDropDownItem
                    :style="'normal'"
                    :id-text="'app-scan-button-title-scan-schedule-targets-1'"
                    :padding="'tw-p-[15px] '"
                    :custom-class="'tw-rounded-[6px] tw-flex'"
                    @click="scheduleTargets"
                  />
                </ButtonDropdown>
              </div>
              <ScheduleModal
                :target-id="''"
                :show="isScheduleModal"
                :title="
                  getComponentUiText(
                    'app-scanning-schedule-modal-title-content-1',
                  )
                "
                :description="
                  getComponentUiText(
                    'app-scanning-schedule-modal-description-1',
                  )
                "
                :button-text="
                  getComponentUiText(
                    'app-scanning-schedule-scans-modal-button-1',
                  )
                "
                :is-edit="true"
                :selected-rows-web-services="selectedWebServicesRows"
                :selected-rows-domains="selectedDomainsRows"
                :is-schedule-multiselect="true"
                :is-show-button-remove-schedule="isShowButtonRemoveSchedule"
                @update:show="isScheduleModal = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, onBeforeMount, Ref, computed, watch } from "vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import ButtonDropdown from "@/components/common/buttonDropdown.vue";
import IconButton from "@/components/common/iconButton.vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import { onMounted } from "vue";
import IssuesMiniDashCard from "@/components/scanning/issuesMiniDashCard.vue";
import IssuesOverTime from "@/components/scanning/issuesOverTime.vue";
import WebServicesTargetTable from "@/components/scanning/webServicesTargetTable.vue";
import DomainsTargetTable from "@/components/scanning/domainsTargetTable.vue";
import store from "@/store";
import ScanMiniDashCard from "@/components/scanning/scanMiniDashCard.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import {
  postScanReportRunDomain,
  postScanReportRunWebService,
} from "@/services/scanning";
import ScheduleModal from "@/components/scanning/scheduleModal.vue";
import {
  MODAL_NAME,
  routers,
  statusScanProgress,
  TYPE_ERROR_LIMIT_START_SCAN,
  TYPE_SCHEDULE,
} from "@/utils/constants";
import router from "@/router";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import { WIZARD_STATE_NAME } from "@/utils/constants";
import { showErrorAPI } from "@/services/apiRoutes";
import { Scanning } from "@/services/apiRoutes/routes";

const notInfoVisible = ref(false);
const backgroundRef = ref(null);
const loading = ref(true);
const selectedWebServicesRows: any = ref([]);
const selectedDomainsRows = ref([]);
const isScheduleModal: Ref<boolean> = ref(false);
const isShowMoreActions = ref(false);
const isLoadingWebServiceTable = ref(false);
const isLoadingDomainTable = ref(false);
const isShowDropdownActions: any = ref(false);

defineProps({
  isLoading: {
    type: Boolean,
    required: false,
  },
});

onBeforeMount(() => initial());

onMounted(() => {
  setTimeout(() => {}, 500);
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("click-box-container")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
});

const handleClickShowDropdown = () => {
  if (isShowBulkActions.value) {
    isShowDropdownActions.value = !isShowDropdownActions.value;
  }
};

const isShowBulkActions = computed(() => {
  return (
    selectedWebServicesRows.value.length >= 1 ||
    selectedDomainsRows.value.length >= 1 ||
    selectedWebServicesRows.value.length + selectedDomainsRows.value.length >= 1
  );
});

const isShowButtonRemoveSchedule = computed(() => {
  let data: any = [];
  if (selectedWebServicesRows.value.length > 0) {
    selectedWebServicesRows.value.forEach((id: any) => {
      const result = store.getters["Scanning/GET_SCHEDULED_ITEM"]({
        type: TYPE_SCHEDULE.webservices,
        id: id,
      });
      if (result !== undefined) {
        data.push(result);
      }
    });
  }

  if (selectedDomainsRows.value.length > 0) {
    selectedDomainsRows.value.forEach((id: any) => {
      const result = store.getters["Scanning/GET_SCHEDULED_ITEM"]({
        type: TYPE_SCHEDULE.domains,
        id: id,
      });
      if (result !== undefined) {
        data.push(result);
      }
    });
  }

  return data.length > 0;
});

watch(
  () => isShowBulkActions.value,
  (value) => {
    if (!value) {
      isShowMoreActions.value = false;
    }
  },
);

const initial = async () => {
  try {
    store.dispatch("Navigation/setActiveHierarchy", [
      getComponentUiText("app-menu-submenu-scan-scanning-1"),
    ]);
    await Promise.all([
      getDataStatusCardDomains(),
      getDataStatusCardWebServices(),
      getReportScheduleWebServices(),
      getReportScheduleDomains(),
      getIgnoreScanReportItem(),
    ]);
    loading.value = false;
    store.dispatch("Scanning/setIsLoadingSchedule", false);
  } catch (error) {
    loading.value = false;
  }
};

const getDataStatusCardDomains = async () => {
  try {
    await store.dispatch("Scanning/fetchScansSummaryDomainsData", {
      scanType: "domains",
    });
  } catch (error: any) {
    showErrorAPI(error, Scanning.getScansSummary);
  }
};

const getDataStatusCardWebServices = async () => {
  try {
    await store.dispatch("Scanning/fetchScansSummaryWebServiceData", {
      scanType: "webservices",
    });
  } catch (error: any) {
    showErrorAPI(error, Scanning.getScansSummary);
  }
};

const getReportScheduleWebServices = async () => {
  await store.dispatch("Scanning/fetchReportScheduleWebServices", {
    scanType: "webservices",
  });
};

const getReportScheduleDomains = async () => {
  await store.dispatch("Scanning/fetchReportScheduleDomain", {
    scanType: "domains",
  });
};

const getIgnoreScanReportItem = async () => {
  await store.dispatch("Scanning/fetchIgnoreScanReportItem");
};

const listScansHistoryWebServices = computed(() => {
  return store.state.Scanning.listScansHistoryWebServices;
});

const listScansHistoryDomains = computed(() => {
  return store.state.Scanning.listScansHistoryDomains;
});

const handleAddScanningTarget = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText("app-scan-scanning-modal-add-target-title-1"),
      description: getComponentUiText(
        "app-scan-scanning-modal-add-target-description-1",
      ),
      buttonText: getComponentUiText(
        "app-scan-scanning-modal-add-target-button-add-web-title-1",
      ),
      titleShowBtnSubmit2: getComponentUiText(
        "app-scan-scanning-modal-add-target-button-add-domain-title-1",
      ),
      buttonRed: false,
      hiddenHelp: false,
      submitButton: true,
    },
    events: {
      "update:data": () => {
        openWizard(WIZARD_STATE_NAME.WEBSERVICES);
      },
      "update:dataSubmit2": () => {
        openWizard(WIZARD_STATE_NAME.DOMAINS);
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openWizard = (type: string) => {
  const query = { type };
  router.push({ path: routers.settingsSetup, query });
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-settings-1"),
    getComponentUiText("app-menu-submenu-settings-setup-1"),
  ]);
  store.dispatch("SetupWizard/onModalSetupWizard", true);
};

const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (isShowBulkActions.value) {
    isShowBulkActions.value = false;
  }
};

const updateWebServicesSelectedRows = (rows: any) => {
  selectedWebServicesRows.value = rows;
};

const updateDomainsSelectedRows = (rows: any) => {
  selectedDomainsRows.value = rows;
};

const changeRunStatusToId = (runStatus) => {
  switch (runStatus) {
    case "In Progress":
      return statusScanProgress.SCAN_IN_PROGRESS;
    case "OK/DONE":
      return statusScanProgress.SCAN_COMPLETE;
    default:
      break;
  }
};
const isUpdateScanTargets = ref(false);

const scanTargets = async () => {
  eventEmitter.emit(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, []);

  if (selectedDomainsRows.value.length > 0) {
    isLoadingDomainTable.value = true;
  }

  if (selectedWebServicesRows.value.length > 0) {
    isLoadingWebServiceTable.value = true;
  }
  try {
    isUpdateScanTargets.value = true;
    if (selectedDomainsRows.value.length > 0) {
      const domainIdsInProgress = listScansHistoryDomains.value
        .filter((service) =>
          service.scanReportRuns.some(
            (run) => run.runStatusId === statusScanProgress.SCAN_IN_PROGRESS,
          ),
        )
        .map((service) => service.domainId);

      const domainIdsDoneSelectedScanTarget = selectedDomainsRows.value.filter(
        (service: any) => !domainIdsInProgress.includes(service),
      );
      if (domainIdsDoneSelectedScanTarget.length > 0) {
        isLoadingDomainTable.value = true;

        const {
          data: { data },
        } = await postScanReportRunDomain(domainIdsDoneSelectedScanTarget);

        const newData = data.map((item) => ({
          domainId: item.domainId,
          scanReportRunId: item.runDomainId,
          scanReportDomainRunId: item.runId,
          scanReportRunTypeId: "man-full",
          scanReportRunType: item.runType,
          startedAt: item.startedAt,
          endedAt: item.endedAt,
          runStatusId: changeRunStatusToId(item.runStatus),
          runStatus: item.runStatus,
          total: "0",
          critical: "0",
          high: "0",
          med: "0",
          low: "0",
        }));

        store.commit("Scanning/SET_UPDATE_SCANS_HISTORY_DOMAINS", newData);
        isLoadingDomainTable.value = false;
      }
    }
    if (selectedWebServicesRows.value.length > 0) {
      isLoadingWebServiceTable.value = true;
      const webServiceIdsInProgress = listScansHistoryWebServices.value
        .filter((service) =>
          service.scanReportRuns.some(
            (run) => run.runStatusId === statusScanProgress.SCAN_IN_PROGRESS,
          ),
        )
        .map((service) => service.webserviceId);

      const webServicesIdsDoneSelectedScanTarget =
        selectedWebServicesRows.value.filter(
          (service: any) => !webServiceIdsInProgress.includes(service),
        );
      if (webServicesIdsDoneSelectedScanTarget.length > 0) {
        const {
          data: { data },
        } = await postScanReportRunWebService(
          webServicesIdsDoneSelectedScanTarget,
        );

        const newData = data.map((item) => ({
          webserviceId: item.webServiceId,
          scanReportRunId: item.runDomainId,
          scanReportWebserviceRunId: item.runId,
          scanReportRunTypeId: "man-full",
          scanReportRunType: item.runType,
          startedAt: item.startedAt,
          endedAt: item.endedAt,
          runStatusId: changeRunStatusToId(item.runStatus),
          runStatus: item.runStatus,
          total: "0",
          critical: "0",
          high: "0",
          med: "0",
          low: "0",
        }));

        eventEmitter.emit(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, []);
        store.commit("Scanning/SET_UPDATE_SCANS_HISTORY_WEB_SERVICES", newData);
      }
    }
  } catch (error) {
    console.log(error);

    if (
      error?.data?.error?.errors?.find(
        (item) =>
          item.type === TYPE_ERROR_LIMIT_START_SCAN.ERROR ||
          item.type === TYPE_ERROR_LIMIT_START_SCAN.ERROR_MAX_CONCURRENT,
      )?.type === TYPE_ERROR_LIMIT_START_SCAN.ERROR ||
      error?.data?.error?.type ===
        TYPE_ERROR_LIMIT_START_SCAN.ERROR_MAX_CONCURRENT
    ) {
      const emitData = {
        component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
        properties: {
          value: {},
          title: getComponentUiText(
            "app-scanning-schedule-modal-title-maximum-scan-limit-reached-1",
          ),
          description: getComponentUiText(
            "app-scanning-schedule-modal-description-maximum-scan-limit-reached-1",
          ),
          buttonText: getComponentUiText(
            "app-scanning-schedule-modal-button-got-it-1",
          ),
          buttonRed: false,
          slotCustom: null,
          hiddenHelp: false,
          isShowBtnCancel: false,
        },
        events: {},
      };
      eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
    } else {
      if (
        error?.data?.error?.type === TYPE_ERROR_LIMIT_START_SCAN.DOMAIN_FAIL
      ) {
        showErrorAPI(error, Scanning.postScanReportRunDomain);
      } else if (
        error?.data?.error?.type === TYPE_ERROR_LIMIT_START_SCAN.WEBSERVICE_FAIL
      ) {
        showErrorAPI(error, Scanning.postScanReportRunWebService);
      }
    }
  } finally {
    isUpdateScanTargets.value = false;
    isLoadingDomainTable.value = false;
    isLoadingWebServiceTable.value = false;
  }
};

const scheduleTargets = () => {
  isShowDropdownActions.value = false;
  isScheduleModal.value = true;
};
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
  background: #ffffff;
}

:deep(.popover-body) {
  // padding: 8px 14px !important;
}

#body {
  flex-wrap: nowrap;
}

.main {
  background: rgba(239, 240, 241, 0.5);
  position: relative;
  height: 100%;
  overflow-y: auto;
}

.scanning-container {
  max-width: 100%;
  position: relative;

  .custom-info {
    margin-top: 20px;
  }
}

.scanning-container {
  .title {
    font-size: 22px;
    line-height: 100%;
    color: #211f58;
  }

  .overview-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(335px, 1fr));
    .scan-card {
      background-color: #fcfcfc;
    }
  }
}

@media (max-width: 640px) {
  .scanning-container {
    .section-header-actions {
      gap: 7px;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .body-container {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
